import {useContext} from "react";
import {AuthContext} from "./Context";

export const StatusCom = ({text,status}) => {
    return (
      <>
        <span className={`${status?"late":""}`}>{text}</span>
      </>
    );
  };